import { catalog } from "../i18n.js";

/** The outline panel (components/Transcript.tsx): everything the model was given and did. */
export const TRANSCRIPT = catalog(
  {
    result: (mimeType: string) => `${mimeType} result`,
    running: "running",
    completed: "completed",
    error: "error",
    interrupted: "interrupted",
    starting: "starting…",
    reasoning: "reasoning",
    hiddenPrompt: "hidden prompt from the host",
    attachment: "attachment",
    usage: (input: number, output: number, reasoning?: number) => `${input} in / ${output} out${reasoning != null ? ` (${reasoning} reasoning)` : ""}`,
    approvalPending: "approval pending",
    approvalApproved: "approval approved",
    approvalDenied: "approval denied",
    approvalExpired: "approval expired",
    condensedLabel: "context condensed",
    condensed: (entries: number, epoch: number) => `${entries} earlier entries were summarised for the model (condensation ${epoch}); the full history stays here.`,
    noActivity: "No activity yet.",
  },
  {
    result: (mimeType) => `hasil ${mimeType}`,
    running: "berjalan",
    completed: "selesai",
    error: "gagal",
    interrupted: "dihentikan",
    starting: "memulai…",
    reasoning: "penalaran",
    hiddenPrompt: "prompt tersembunyi dari host",
    attachment: "lampiran",
    usage: (input, output, reasoning) => `${input} masuk / ${output} keluar${reasoning != null ? ` (${reasoning} penalaran)` : ""}`,
    approvalPending: "menunggu persetujuan",
    approvalApproved: "disetujui",
    approvalDenied: "ditolak",
    approvalExpired: "kedaluwarsa",
    condensedLabel: "konteks diringkas",
    condensed: (entries, epoch) => `${entries} entri sebelumnya diringkas untuk model (peringkasan ke-${epoch}); riwayat lengkapnya tetap di sini.`,
    noActivity: "Belum ada aktivitas.",
  },
);
